const assetGetData = async (keyOrID, size, store) => {
    console.log('load asset', keyOrID);
    const asset = await store.load('asset', keyOrID);
    await store.load('repository', asset.repository?.key);
    const signedUrl = await asset.getSignedUrl(size);
    return signedUrl;
};
export default assetGetData;
//# sourceMappingURL=assetGetData.js.map